import { FC } from "react";
import { DialogTitle } from "@headlessui/react";
import { X } from "lucide-react";

import { Styled } from "../../../types";
import { BORDER_STYLES } from "../../../detailedPages/styles";
import { Button } from "../../../molecules/Button";
import { CLOSE_ICON_STYLES } from "../../../../styles";

type SlideOverTitleProps = {
  handleClose: () => void;
  title: string;
  disabled?: boolean;
};

export const SlideOverTitle: FC<
  React.PropsWithChildren<SlideOverTitleProps & Styled>
> = ({ handleClose, title, disabled, children, className }) => {
  return (
    <div className={className ?? `${BORDER_STYLES} border-b pb-4 sm:pb-8`}>
      <DialogTitle className="text-primary relative pt-10 sm:pt-8 text-center text-xl sm:text-2xl font-medium dark:text-white">
        <Button
          title="Close panel"
          className={`${CLOSE_ICON_STYLES} top-2.5 sm:top-5 right-2.5 sm:right-5 ml-3 flex h-7 items-center rounded-full`}
          onClick={handleClose}
          buttonType="iconOnly"
          disabled={disabled}
        >
          <X />
        </Button>
        {title}
      </DialogTitle>
      {children}
    </div>
  );
};
